<template>
  <div id="SysNotarizationList">
    <eb-header>
      <eb-break-crumb slot="breakCrumb" />
      <eb-search @search-click="searchData" slot="search" ref="searchInput" placeholder="请输入项目名称、项目编号、申请人、申请单位" />
    </eb-header>
    <eb-date-search :listRequestData="listRequestData" ref="radioSelect">
      <el-button name="slot" class="eb-button-group-btn eb-button-orange button" @click="searchDateClick">搜索</el-button>
      <el-button name="slot" class="eb-button-group-btn eb-button-orange button" @click="downloadReport">下载报告</el-button>
    </eb-date-search>
    <div class="table table-box eb-table">
      <el-table :data.sync="pageData" tooltip-effect="dark" style="width: 100%" @sort-change="sortChange" @current-change="handleCurrentRowChange">
        <el-table-column width="30">
          <template slot-scope="scope">
            <el-radio class="eb-radio" :label="scope.$index" v-model="radioValue"></el-radio>
          </template>
        </el-table-column>
        <el-table-column type="index" label="序号" width="50"></el-table-column>
        <el-table-column prop='createTime' label="申请时间" width="180" sortable='custom'>
          <template slot-scope="scope">
            {{applyTime(scope.row.createTime)}}
          </template>
        </el-table-column>
        <el-table-column prop='projectName' label="项目名称" min-width="130" sortable='custom'></el-table-column>
        <el-table-column prop='projectCode' label="项目编号" min-width="130" sortable='custom'></el-table-column>
        <el-table-column prop='applyOrgName' label="申请单位" min-width="150" sortable='custom'></el-table-column>
        <el-table-column prop='applyUserName' label="申请人" width="110" sortable='custom'>
          <template slot-scope="scope">
            <a @click="showUserInfo(scope.row.applyUserId)" href="javascript:void(0)" class="a-font-red">{{scope.row.applyUserName}}</a>
          </template>
        </el-table-column>
        <el-table-column prop='payStatus' label="鉴证状态" width="100" sortable='custom'>
          <template slot-scope="scope">
            {{notarizationStatus(scope.row.payStatus)}}
          </template>
        </el-table-column>
        <el-table-column label="查看申请">
          <template slot-scope="scope">
            <a @click="showNotarizationInfo(scope.row.applyId)" href="javascript:void(0)" class="a-font-red">鉴证详情</a>
          </template>
        </el-table-column>
      </el-table>
      <eb-pagination :current-page.sync="listRequestData.start" v-if="recordsTotal" @current-change="paginationData" :total="recordsTotal" />
    </div>
  </div>
</template>
<script>
import ebHeader from '@/components/common/eb-header';
import ebBreakCrumb from '@/components/common/eb-break-crumb';
import ebSearch from '@/components/common/eb-search';
import ebDateSearch from '@/components/common/eb-date-search';
import ebPagination from '@/components/common/eb-pagination/eb-pagination';
import { findSysNotarizationList } from '@/services/notarization/notarization-service';
import eventBus from '@/plugins/event-bus';
import { baseURL } from '@/plugins/axios';
export default {
  name: 'SysNotarizationList',
  components: {
    ebHeader,
    ebBreakCrumb,
    ebSearch,
    ebDateSearch,
    ebPagination
  },
  data() {
    return {
      loading: true,
      pageData: [],
      recordsTotal: null,
      listRequestData: {
        start: 1,
        length: 10,
        orderProp: 'createTime',
        orderType: 'desc',
        startTime: '',
        endTime: '',
        content: '',
        selected: '0'
      },
      radioValue: null,
      currentSelectedRow: null
    };
  },
  created() {
    this.initNotarizationList();
  },
  methods: {
    async initNotarizationList() {
      this.$root.layout.isLoading = true;
      try {
        let { data } = await findSysNotarizationList(this.listRequestData);
        if (data.returnCode === '01') {
          this.pageData = data.data;
          this.recordsTotal = data.recordsTotal;
        } else {
          this.$message.error('查询鉴证申请列表失败！');
        }
      } catch (error) {
        this.$message.error('请检查服务器连接!');
      }
      this.$root.layout.isLoading = false;
    },
    notarizationStatus(status) {
      return this.$options.filters['notarizationStatus'](status);
    },
    applyTime(time) {
      return this.$options.filters['dateTimeStandardFormat'](time);
    },
    // 点击搜索
    searchData: function(searchKey) {
      if (searchKey === '') {
        this.$refs.radioSelect.selected = '0';
        this.$refs.radioSelect.selectedCurrent('0');
      }
      this.listRequestData.content = searchKey;
      this.initNotarizationList();
    },
    // 当前选中行改变操作
    handleCurrentRowChange(currRow) {
      this.radioValue = this.pageData.indexOf(currRow);
      this.currentSelectedRow = currRow;
    },
    sortChange(columnData) {
      this.listRequestData.orderProp = columnData.prop;
      switch (columnData.order) {
        case 'descending':
          this.listRequestData.orderType = 'desc';
          break;
        case 'ascending':
          this.listRequestData.orderType = 'asc';
          break;
      }
      this.initNotarizationList();
    },
    // 分页
    paginationData(pageNum) {
      this.listRequestData.start = pageNum;
      this.initNotarizationList();
    },
    searchDateClick() {
      this.listRequestData.content = this.$refs.searchInput.text;
      this.initNotarizationList();
    },
    showUserInfo(userId) {
      eventBus.$emit('userInfoDialog', userId);
    },
    downloadReport() {
      if (this.radioValue === null) {
        this.$message.error('请选择要下载报告的数据');
        return false;
      }
      if (this.currentSelectedRow.projectMethod === '1') {
        location.href =
          baseURL + '/api/reports/r5/' + this.currentSelectedRow.applyId + '/' + this.currentSelectedRow.projectId + '.pdf';
      } else if (this.currentSelectedRow.projectMethod === '2') {
        location.href =
          baseURL + '/api/reports/r6/' + this.currentSelectedRow.applyId + '/' + this.currentSelectedRow.projectId + '.pdf';
      }
    },
    showNotarizationInfo(applyId) {
      this.$router.push('/notarization/detail/' + applyId);
    }
  }
};
</script>
<style lang="less" scoped>
#SysNotarizationList {
  .table {
    padding: 10px 10px;
    max-width: 100%;
    margin-bottom: 20px;
    .a-font-red {
      color: #fb5b3b;
    }
  }
  .button {
    height: 22px;
    width: 82px;
  }
}
</style>
